import*as React from"react";import{Form as AntdForm}from"antd";import styled from"@emotion/styled";import{mediaQuery}from"@wp/src/components/common/grid";import{css}from"@emotion/react";export const Form=props=>{return React.createElement(AntdForm,props)};export const FromList=AntdForm.List;export const requiredFieldAsteriskStyles=css`
  /* Add asterisk after the label text */
  &::after {
    content: '*'; /* The asterisk to show */
    color: inherit; /* Inherits the label's text color */
    visibility: inherit; /* Ensures visibility matches the label */
  }
`;const StyledFormItem=styled(AntdForm.Item)`
  label {
    width: 100%;
  }
  label.ant-form-item-required {
    ${mediaQuery({fontSize:["14px","10px","11px","12px","13px","14px"]})}

    :not(.ant-form-item-required-mark-optional) {
      // Remove the default asterisk
      &::before {
        content: none !important;
      }
      ${props=>props.hideAsterisk?null:requiredFieldAsteriskStyles}
    }
  }
`;export const FormItem=props=>{return React.createElement(StyledFormItem,props)};export const isFormContainsErrors=form=>Boolean(form.getFieldsError().filter(({errors})=>errors.length).length);export let FieldsTouchCondition=function(FieldsTouchCondition){FieldsTouchCondition["All"]="all";FieldsTouchCondition["Any"]="any";return FieldsTouchCondition}({});export const shouldFormSubmitBeDisabled=(form,fieldsTouchCondition=FieldsTouchCondition.All)=>!form.isFieldsTouched(fieldsTouchCondition===FieldsTouchCondition.All)||isFormContainsErrors(form);export const useForm=AntdForm.useForm;export const useFormWatch=AntdForm.useWatch;export const useFormInstance=AntdForm.useFormInstance;export const setFormFieldValue=(form,fieldName,value)=>{const existingFormValues=form.getFieldsValue(true);form.setFieldsValue({...existingFormValues,[fieldName]:value})};